import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { PymtList } from '@/sc/entities/pymt/PymtList';
import { useEntityMgr } from '../../../common/entityFramework/entityView/EntityMgrContext';
import { CtrtList } from '../ctrt/CtrtList';
import { CustActiveList } from '../custActive/CustActiveList';
import { CustAddrList } from '../custAddr/CustAddrList';
import { CustContactList } from '../custContact/CustConactList';
import { CustCotList } from '../custCot/CustCotList';
import { CustExcList } from '../custExc/CustExcList';
import { CustIdentList } from '../custIdent/CustIdentList';
import { CustInfoList } from '../custInfo/CustInfoList';
import { CustRelList } from '../custRel/CustRelList';
import { FormList } from '../form/FormList';
import { CustEligProgList } from './CustEligProgList';
import { CustForm } from './CustForm';

export const CustDetail = () => {
  const { entityObj } = useEntityMgr();
  const { hasRole } = usePrincipal();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <CustForm /> },
    { id: 'custActive', label: 'Active', content: <CustActiveList custId={entityObj.id} /> },
    { id: 'custAddr', label: 'Addresses', content: <CustAddrList custId={entityObj.id} /> },
    { id: 'custIdent', label: 'Identifiers', content: <CustIdentList custId={entityObj.id} /> },
    { id: 'custCot', label: 'Classes of Trade', content: <CustCotList custId={entityObj.id} /> },
    { id: 'custRel', label: 'Relationships', content: <CustRelList custObj={entityObj} /> },
    { id: 'custContact', label: 'Contacts', content: <CustContactList custId={entityObj.id} /> },
    { id: 'custExc', label: 'Exclusions', content: <CustExcList custId={entityObj.id} /> },
    {
      id: 'entityProp',
      label: 'Properties',
      content: <EntityPropList parentEntity="CUST" parentEntityObj={entityObj} />,
    },
    ...(hasRole('MD_FORM_VIEW') ?
      [{ id: 'form', label: 'Owned Formularies', content: <FormList ownerCustId={entityObj.id} /> }]
    : []),
    { id: 'ctrt', label: 'Owned Contracts', content: <CtrtList ownerCustId={entityObj.id} /> },
    { id: 'eligProg', label: 'Eligible Programs', content: <CustEligProgList custId={entityObj.id} /> },
    { id: 'pymt', label: 'Payments', content: <PymtList payeeCustId={entityObj.id} /> },
    { id: 'custInfo', label: 'External Info', content: <CustInfoList custId={entityObj.id} /> },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
